import { Base } from '../base-component';
import Slider from '../slider/slider.component';
import './logo-carousel.component.scss';

export class LogoCarousel extends Base {

	sliderContainer: Element;
	sliderPagination: Element;
	sliderPaginationContainer: Element;
	sliderConfig: SwiperOptions;
	sliderNext: Element;
	sliderPrev: Element;
	windowWidth: number;
	sliderItems: any;
	breakpoints: {};

	constructor(element: Element){

		super(element);

	}

	init(){

		this.sliderContainer = this.element.querySelector('.swiper-container');
		this.sliderPagination = this.element.querySelector('.swiper-pagination');
		this.sliderPaginationContainer = this.element.querySelector('.slider__pagination-container');
		this.sliderNext = this.element.querySelector('.swiper-button-next');
		this.sliderPrev = this.element.querySelector('.swiper-button-prev');
		this.sliderItems = Array.from(this.element.querySelectorAll('.logo-carousel-item__slider'));
		this.windowWidth = document.documentElement.clientWidth;
		
		if(this.sliderItems.length > 5) {

			this.breakpoints = {
				1200: {
					initialSlide: 0,
					slidesPerView: 5,
					spaceBetween: 30,
				},
				992: {
					initialSlide: 0,
					slidesPerView: 4,
					spaceBetween: 20,
				},
				768: {
					initialSlide: 0,
					slidesPerView: 3,
					spaceBetween: 20,
				},
				576: {
					initialSlide: 0,
					slidesPerView: 2,
					spaceBetween: 15,
				},
				420: {
					initialSlide: 0,
					slidesPerView: 1,
					spaceBetween: 15,
				}
			};

			this.sliderConfig = {
				slidesPerView: 5,
				spaceBetween: 30,
				initialSlide: 0,
				breakpoints: this.breakpoints,
				pagination: {
					el: this.sliderPagination,
					type: 'bullets',
					clickable: true
				},
				navigation: {
					nextEl: this.sliderNext,
					prevEl: this.sliderPrev,
				}
			};

		}else if(this.sliderItems.length === 5) {

			this.sliderPaginationContainer.classList.add('js-logo-carousel-hidden-arrow');

			this.breakpoints = {
				1200: {
					initialSlide: 0,
					slidesPerView: 5,
					spaceBetween: 30,
				},
				992: {
					initialSlide: 0,
					slidesPerView: 4,
					spaceBetween: 20,
				},
				768: {
					initialSlide: 0,
					slidesPerView: 3,
					spaceBetween: 20,
				},
				576: {
					initialSlide: 0,
					slidesPerView: 2,
					spaceBetween: 15,
				},
				420: {
					initialSlide: 0,
					slidesPerView: 1,
					spaceBetween: 15,
				}
			};

			this.sliderConfig = {
				slidesPerView: 5,
				spaceBetween: 30,
				initialSlide: 0,
				breakpoints: this.breakpoints,
				pagination: {
					el: this.sliderPagination,
					type: 'bullets',
					clickable: true
				},
				navigation: {
					nextEl: this.sliderNext,
					prevEl: this.sliderPrev,
				}
			};

		}else if(this.sliderItems.length === 4) {

			this.element.classList.add('js-logo-carousel-4-columns');
			this.sliderPaginationContainer.classList.add('js-logo-carousel-hidden-arrow');

			this.breakpoints = {
				1200: {
					initialSlide: 0,
					slidesPerView: 4,
					spaceBetween: 30,
				},
				992: {
					initialSlide: 0,
					slidesPerView: 4,
					spaceBetween: 20,
				},
				768: {
					initialSlide: 0,
					slidesPerView: 3,
					spaceBetween: 20,
				},
				576: {
					initialSlide: 0,
					slidesPerView: 2,
					spaceBetween: 15,
				},
				420: {
					initialSlide: 0,
					slidesPerView: 1,
					spaceBetween: 15,
				}
			};

			this.sliderConfig = {
				slidesPerView: 4,
				spaceBetween: 30,
				initialSlide: 0,
				breakpoints: this.breakpoints,
				pagination: {
					el: this.sliderPagination,
					type: 'bullets',
					clickable: true
				},
				navigation: {
					nextEl: this.sliderNext,
					prevEl: this.sliderPrev,
				}
			};

		}else if(this.sliderItems.length === 3) {

			this.element.classList.add('js-logo-carousel-3-columns');
			this.sliderPaginationContainer.classList.add('js-logo-carousel-hidden-arrow');

			this.breakpoints = {
				1200: {
					initialSlide: 0,
					slidesPerView: 3,
					spaceBetween: 30,
				},
				992: {
					initialSlide: 0,
					slidesPerView: 3,
					spaceBetween: 20,
				},
				768: {
					initialSlide: 0,
					slidesPerView: 3,
					spaceBetween: 20,
				},
				576: {
					initialSlide: 0,
					slidesPerView: 2,
					spaceBetween: 15,
				},
				420: {
					initialSlide: 0,
					slidesPerView: 1,
					spaceBetween: 15,
				}
			};

			this.sliderConfig = {
				slidesPerView: 3,
				spaceBetween: 30,
				initialSlide: 0,
				breakpoints: this.breakpoints,
				pagination: {
					el: this.sliderPagination,
					type: 'bullets',
					clickable: true
				},
				navigation: {
					nextEl: this.sliderNext,
					prevEl: this.sliderPrev,
				}
			};

		}else if(this.sliderItems.length === 2) {

			this.element.classList.add('js-logo-carousel-2-columns');
			this.sliderPaginationContainer.classList.add('js-logo-carousel-hidden-arrow');

			this.breakpoints = {
				1200: {
					initialSlide: 0,
					slidesPerView: 2,
					spaceBetween: 30,
				},
				992: {
					initialSlide: 0,
					slidesPerView: 2,
					spaceBetween: 20,
				},
				768: {
					initialSlide: 0,
					slidesPerView: 2,
					spaceBetween: 20,
				},
				576: {
					initialSlide: 0,
					slidesPerView: 2,
					spaceBetween: 15,
				},
				420: {
					initialSlide: 0,
					slidesPerView: 1,
					spaceBetween: 15,
				}
			};

			this.sliderConfig = {
				slidesPerView: 2,
				spaceBetween: 30,
				initialSlide: 0,
				breakpoints: this.breakpoints,
				pagination: {
					el: this.sliderPagination,
					type: 'bullets',
					clickable: true
				},
				navigation: {
					nextEl: this.sliderNext,
					prevEl: this.sliderPrev,
				}
			};

		}else{

			this.element.classList.add('js-logo-carousel-1-columns');
			this.sliderPaginationContainer.classList.add('js-logo-carousel-hidden-arrow');

			this.sliderConfig = {
				slidesPerView: 1,
				spaceBetween: 30,
				initialSlide: 0,
			};

		}

		Slider.init(this.sliderContainer, this.sliderConfig);

	}

	bindEvents() {

	}

}


// WEBPACK FOOTER //
// ./components/logo-carousel/logo-carousel.component.ts